import React, { forwardRef } from 'react'

import './ImageCard.css'

type Props = {
  title?: string
  description?: string | null
  imageUrl?: string | null
  isSelected: boolean
  onClick?: () => void
}

export const ImageCard = forwardRef<HTMLDivElement, Props>(
  ({ title, description, imageUrl, isSelected, onClick }, ref) => {
    const ariaLabel = `${title}${description ? `, ${description}` : ''}`

    return (
      <div
        ref={ref}
        className={`will-image-card ${isSelected ? 'is-selected' : ''}`}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick?.()
          }
        }}
        role="button"
        tabIndex={0}
        aria-pressed={isSelected}
        aria-label={ariaLabel}
      >
        <div className="will-image-card-content">
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        <div className="will-image-card-image">
          {imageUrl && <img src={imageUrl} alt={title || 'Location image'} />}
        </div>
      </div>
    )
  }
)

ImageCard.displayName = 'ImageCard'
